import _ from 'lodash'
import { aggregateOffers } from './campaign-designer/utils'
import { keyBy, setQueryStringVariables } from '../../components/utils/utils'
import backend from '../../components/utils/backend'
import bodyMappers from './campaign-designer/body-mappers'
import updateCampaignSectionCC from './campaign-designer/functions/updateCampaignSectionCC'
import updateCampaignSectionDDS from './campaign-designer/functions/updateCampaignSectionDDS'
import updateCampaignSectionSalesFull from './campaign-designer/functions/updateCampaignSectionSalesFull'
import updateCampaignSectionTechnical from './campaign-designer/functions/updateCampaignSectionTechnical'

function mapBody (campaign, config, recordType) {
  if (COMMERCIAL_CAMPAIGN_RECORD_TYPES.includes(recordType)) {
    return bodyMappers.cc(campaign, config)
  } else if (DDS_CAMPAIGN_RECORD_TYPES.includes(recordType)) {
    return bodyMappers.dds(campaign)
  } else if (SALES_FULL_RECORD_TYPES.includes(recordType)) {
    return bodyMappers.sales(campaign)
  } else if (TECHNICAL_CAMPAIGN_RECORD_TYPES.includes(recordType)) {
    return bodyMappers.technical(campaign)
  } else {
    throw new Error(`Unhandled record type ${recordType}`)
  }
}

const COMMERCIAL_CAMPAIGN_RECORD_TYPES = [
  'full',
  'header',
  'vhr',
  'sales'
]

const DDS_CAMPAIGN_RECORD_TYPES = [
  'ddsChild',
  'ddsParent'
]

const TECHNICAL_CAMPAIGN_RECORD_TYPES = [
  'technical'
]

const SALES_FULL_RECORD_TYPES = [
  'salesFull'
]

export default {
  state: {
    campaigns: undefined,
    currentCampaign: {
      config: {},
      oldConfig: {}
    },
    offers: [],
    currentCampaignConfig: {},
    tempOffers: []
  },
  getters: {
    campaigns: state => state.campaigns,
    currentCampaign: state => state.currentCampaign,
    ddsCampaigns (state) {
      return state.campaigns.filter(campaign => campaign.type === 'sl_dds')
    },
    oldConfig (state) {
      if (state.campaign && state.campaign.oldConfig) {
        return JSON.parse(state.campaign.oldConfig)
      } else {
        return {}
      }
    },
    state: state => state
  },
  mutations: {
    'INIT_STATE': function (state, newState) {
      Object.keys(state).forEach(key => delete state[key])
      Object.keys(newState).forEach(key => { state[key] = newState[key] })
    },
    'LOAD_CONFIG': function (state, config) {
      state.currentCampaignConfig = _.cloneDeep(config)
      state.currentCampaign.config = config
    },
    changeAttrInCampaignData( state, changeInfo ){
      if( state.currentCampaign && state.currentCampaign.config && state.currentCampaign.config.campaignData ){
        if( changeInfo && changeInfo.attrName && (changeInfo.attrVal!==undefined) && typeof (changeInfo.attrName)=='string' && changeInfo.attrName!='' ){
          state.currentCampaign.config.campaignData[ changeInfo.attrName ] = changeInfo.attrVal
        }
      }
    },
    changeAttrInFlatCampaign( state, changeInfo ){
      if( state.currentCampaign && state.currentCampaign ){
        if( changeInfo && changeInfo.attrName && (changeInfo.attrVal!==undefined) && typeof (changeInfo.attrName)=='string' && changeInfo.attrName!='' ){
          state.currentCampaign[changeInfo.attrName] = changeInfo.attrVal
        }
      }
    },
    'LOAD_STATE': function (state, campaign) {
      state.currentCampaign = campaign
    },
    'LOAD_OLD_STATE': function (state) {
      const oldState = JSON.parse(state.oldConfig)
      delete state.currentCampaign.oldConfig
      state.currentCampaign = oldState
    },
    'SAVE_OFFERS': function (state, offers) {
      state.tempOffers = _.cloneDeep(offers)
    },
    'SAVE_OLD_STATE': function (state) {
      const oldConfigString = JSON.stringify(_.omit(state.currentCampaign))
      state.oldConfig = oldConfigString
    },
    'CLEAR_PREVIEW': function (state) {
      state.currentCampaign.config.preview = {}
      state.currentCampaign.preview = {}
    },
    'UPDATE_CURRENT_CAMPAIGN_CONFIG_SECTION': function (state, payload) {
      const { data, section } = payload
      state.currentCampaignConfig[section] = data
      //if (section == 'filters') console.log('Updating current config section: ', data)
    },
    'UPDATE_CAMPAIGN_CONFIG_SECTION': function (state, payload) {
      const { data, section } = payload
      //if (section == 'filters') console.log('UPDATE_CAMPAIGN_CONFIG_SECTION: ', section)
      state.currentCampaign.config[section] = data
      //if (section == 'filters') console.log('Updating campaign config section: ', data)
    },
    'SET_CAMPAIGNS': function (state, campaigns) {
      state.campaigns = campaigns
    },
    'SET_CAMPAIGN_STATUS': function (state, status) {
      state.currentCampaign.status = status
    },
    'SET_INFORMATIVE_CAMPAIGN': function (state, value) {
      state.currentCampaign.config.userPreferences.onlyInformativeCampaign = value
    },
    'SET_USER_CAN_EDIT_EXCLUDED_VIN': function (state, { sectionId, value }) {
      if (!sectionId) {
        state.currentCampaign.config.userPreferences.userCanEditExcludedVIN = value
      } else {
        if (typeof state.currentCampaign.config.userPreferences.userCanEditExcludedVIN !== 'object') {
          state.currentCampaign.config.userPreferences.userCanEditExcludedVIN = {
            [sectionId]: value
          }
        } else {
          state.currentCampaign.config.userPreferences.userCanEditExcludedVIN[sectionId] = value
        }
      }
    },
    'SET_CAMPAIGN_FIELD': function (state, { name, value }) {
      state.currentCampaign[name] = value
    },
    'SET_USER_PREFERENCE': function (state, { name, value }) {
      state.currentCampaign.config.userPreferences[name] = value
    },
    'SET_OFFERS': function (state, offers) {
      state.offers = offers
    }
  },
  actions: {
    activateCampaign ({ commit, rootGetters }, payload) {
      return new Promise(async (resolve, reject) => {
        const { campaignId, vm } = payload
        try {
          const response = await backend.post(`/api/v1/mc-api/campaign/${campaignId}/publish`, rootGetters['session/accessToken'])
          if (response.statusCode !== 200) {
            if (response.statusCode === 403) {
              throw new Error(vm.$t('message.forbiddenActivation'))
            }
            console.error('Error during activation', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            const record = response.body
            commit('LOAD_STATE', record)
            commit('LOAD_CONFIG', record.config)
            resolve(record)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    deleteCampaign ({ rootGetters }, campaignId) {
      return new Promise(async (resolve, reject) => {
        try {
          await backend.delete(`/api/v1/campaign/${campaignId}`, rootGetters['session/accessToken'])
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    getCampaign ({ commit, dispatch, rootGetters }, campaignId) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch('clearCampaignData')
          const campaign = (await backend.get(`/api/v1/campaign/${campaignId}`, rootGetters['session/accessToken'])).body
          commit('LOAD_STATE', campaign)
          commit('LOAD_CONFIG', campaign.config)
          resolve(campaign)
        } catch (error) {
          reject(error)
        }
      })
    },
    getDealersMap ({ dispatch, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const config = (await backend.get('/api/v1/dealer', rootGetters['session/accessToken'])).body
          resolve(config)
        } catch (error) {
          reject(error)
        }
      })
    },
    getEmptyConfig ({ dispatch, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch('clearCampaignData')
          const config = (await backend.get('/api/v1/campaign/new/config', rootGetters['session/accessToken'])).body
          //console.log('CONFIG IS', config)
          resolve(config)
        } catch (error) {
          reject(error)
        }
      })
    },
    getCampaigns ({ commit, rootGetters }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          const decodedAccessToken = rootGetters['session/decodedAccessToken']
          const endpoint = setQueryStringVariables('/api/v1/campaign', { ...params, scopes: decodedAccessToken.scopes.join(',') })
          const campaigns = (await backend.get(endpoint, rootGetters['session/accessToken'])).body
          commit('SET_CAMPAIGNS', campaigns)
          resolve(campaigns)
        } catch (error) {
          reject(error)
        }
      })
    },
    getModels ({ rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const modelsMap = (await backend.get('/api/v1/models', rootGetters['session/accessToken'])).body
          resolve(modelsMap)
        } catch (error) {
          reject(error)
        }
      })
    },
    getAssets({ rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const AssetComputedName = (await backend.get('/api/v1/assets', rootGetters['session/accessToken'])).body
          resolve(AssetComputedName)
        } catch (error) {
          reject(error)
        }
      })
    },
    getBUAbbr({ rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const BUAbbr = (await backend.get('/api/v1/buabbr', rootGetters['session/accessToken'])).body
          resolve(BUAbbr)
        } catch (error) {
          reject(error)
        }
      })
    },
    getPublishedAssets({ rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const PublishedAssets = (await backend.get('/api/v1/published-assets', rootGetters['session/accessToken'])).body
          resolve(PublishedAssets)
        } catch (error) {
          reject(error)
        }
      })
    },
    getLCDV({ rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const lcdv = (await backend.get('/api/v1/lcdv', rootGetters['session/accessToken'])).body
          resolve(lcdv)
        } catch (error) {
          reject(error)
        }
      })
    },
    getMvs ({ rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const mvsMap = (await backend.get('/api/v1/mvs', rootGetters['session/accessToken'])).body
          resolve(mvsMap)
        } catch (error) {
          reject(error)
        }
      })
    },
    getPreview ({ commit, rootGetters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { campaignId } = payload
          const campaign = (await backend.get(`/api/v1/campaign/${campaignId}`, rootGetters['session/accessToken'])).body
          commit('LOAD_STATE', campaign)
          commit('LOAD_CONFIG', campaign.config)
          resolve(campaign.preview)
        } catch (error) {
          reject(error)
        }
      })
    },
    async getOffer ({ rootGetters }, offerId) {
      try {
        const response = (await backend.get(`/api/v1/offer/${offerId}`, rootGetters['session/accessToken'])).body
        console.log("offer response is : ",response)
        if (response.httpCode && response.httpCode === '404') {
          throw new Error(`Offer with id ${offerId} not found`)
        } else {
          return response
        }
      } catch (error) {
        throw error
      }
    },
    getOffers ({ commit, rootGetters }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          const endpoint = setQueryStringVariables('/api/v1/offer', params)
          const offers = (await backend.get(endpoint, rootGetters['session/accessToken'])).body
          const aggOffers = aggregateOffers(offers)
          const mapped = keyBy(aggOffers, 'offerId')
          commit('SET_OFFERS', mapped)

          resolve(mapped)
        } catch (error) {
          reject(error)
        }
      })
    },
    loadConfig ({ commit }, config) {
      return new Promise(async (resolve, reject) => {
        commit('LOAD_CONFIG', config)
        resolve()
      })
    },
    changeAttrInCampaignData( context , changeInfo ){
      context.commit( 'changeAttrInCampaignData',changeInfo )
    },
    changeAttrInFlatCampaign( context , changeInfo ){
      context.commit( 'changeAttrInFlatCampaign',changeInfo )
    },
    updateCampaignSection ({ commit, getters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { recordType } = payload

          if (COMMERCIAL_CAMPAIGN_RECORD_TYPES.includes(recordType)) {
            await updateCampaignSectionCC({ commit, getters }, payload)
          } else if (DDS_CAMPAIGN_RECORD_TYPES.includes(recordType)) {
            await updateCampaignSectionDDS({ commit, getters }, payload, recordType)
          } else if (TECHNICAL_CAMPAIGN_RECORD_TYPES.includes(recordType)) {
            await updateCampaignSectionTechnical({ commit }, payload)
          } else if (SALES_FULL_RECORD_TYPES.includes(recordType)) {
            await updateCampaignSectionSalesFull({ commit, getters }, payload)
          }
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
    loadOldState ({ commit }) {
      commit('LOAD_OLD_STATE')
    },
    saveOldState ({ commit }) {
      commit('SAVE_OLD_STATE')
    },
    save ({ commit, getters, rootGetters }, { recordType }) {
      return new Promise(async (resolve, reject) => {
        try {
          const config = getters.state.currentCampaignConfig
          const body = mapBody({ ...getters.state.currentCampaign, status: 'Draft' }, config, recordType)

          const response = await backend.post('/api/v1/campaign', rootGetters['session/accessToken'], body)
          if (response.statusCode !== 201) {
            console.error('Error during save', response.body)
            throw new Error(response.body.statusMessage)
          } else {
            const record = response.body
            commit('SET_CAMPAIGN_STATUS', 'Draft')
            resolve(record)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    // Preview
    checkPreview ({ rootGetters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { jobId } = payload
          const response = (await backend.get(`/api/v1/job/${jobId}`, rootGetters['session/accessToken'])).body

          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    clearPreview ({ commit }) {
      commit('CLEAR_PREVIEW')
    },
    startPreview ({ commit, dispatch, rootGetters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { campaignId, department } = payload

          const body = {
            type: 'Preview',
            detail: {
              campaignId,
              department
            }
          }

          const response = (await backend.post(`/api/v1/job`, rootGetters['session/accessToken'], body)).body
          const previewObject = { section: 'preview', data: { jobId: response.id } }
          commit('UPDATE_CAMPAIGN_CONFIG_SECTION', previewObject)
          dispatch('update', payload)
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    },
    update ({ getters, rootGetters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { campaignId, recordType } = payload
          const config = getters.state.currentCampaignConfig

          const body = mapBody({ ...getters.state.currentCampaign }, config, recordType)

          const response = await backend.put(`/api/v1/campaign/${campaignId}`, rootGetters['session/accessToken'], body)
          if (response.statusCode !== 200) {
            console.error('Error during update', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            resolve(response.body)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    clearCampaignData ({ commit }) {
      const clearState = {
        campaigns: undefined,
        currentCampaign: {
          config: {},
          oldConfig: {}
        },
        currentCampaignConfig: {},
        tempOffers: []
      }

      commit('INIT_STATE', clearState)
    },
    // Cleanup campaign
    overwriteCampaign ({ rootGetters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const { id, campaign } = payload
          const response = await backend.put(`/api/v1/campaign/${id}`, rootGetters['session/accessToken'], campaign)

          if (response.statusCode !== 200) {
            console.error('Error during update', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            resolve(response.body)
          }
        } catch (error) {
          reject(error)
        }
      })
    }
  },
  namespaced: true
}
